import { Box } from '@zillow/constellation-10';

type BoxProps = React.ComponentProps<typeof Box>;

export const StyledContainer = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    css={{
      width: '100%',
      border: '1px solid',
      // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base-token usage; was warn-only under ESLint's pandaLint
      borderColor: 'gray.300',
      borderRadius: '5px',
      backgroundColor: 'white',
      padding: 'lg',
      marginBottom: 'sm',
    }}
    {...props}
  >
    {children}
  </Box>
);

export const StyledSummaryBox = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    css={{
      textAlign: 'center',
      padding: '32px 0',
    }}
    {...props}
  >
    {children}
  </Box>
);

export const StyledBalanceBox = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    css={{
      textAlign: { lg: 'right' },
    }}
    {...props}
  >
    {children}
  </Box>
);
